import { render, staticRenderFns } from "./DesignExpend.vue?vue&type=template&id=f9dcbf70&scoped=true"
import script from "./DesignExpend.vue?vue&type=script&lang=js"
export * from "./DesignExpend.vue?vue&type=script&lang=js"
import style0 from "./DesignExpend.vue?vue&type=style&index=0&id=f9dcbf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dcbf70",
  null
  
)

export default component.exports